const PHRASES = [
  "Capital Governance",
  "Every Dollar Has a Job",
  "Risk Controls",
  "Execution Discipline",
  "Continuous Learning",
  "Hussar Lab",
  "Benchmarking",
  "Accounting Integrity",
];

export default function Marquee() {
  const row = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-hussar-gold/10 bg-hussar-bg2/40 py-5 overflow-hidden select-none"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-hussar-gold/40 text-sm uppercase tracking-[0.35em] px-8">{p}</span>
                <span className="text-hussar-gold/25 text-[10px]">◆</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
